import React, { Component } from "react";
import { Table, THead, TH, TD, TBody, TR } from "@react/react-spectrum/Table";
import DataSection from "../../comps/DataSection/DataSection";
import formFields from "../config/formFields";
import Button from "@react/react-spectrum/Button";
import Link from "@react/react-spectrum/Link";
import Dialog from "@react/react-spectrum/Dialog";
import Wait from "@react/react-spectrum/Wait";
import Heading from "@react/react-spectrum/Heading";
import { Provider } from "react-redux";
import store from "../../store";
import { Translate } from "react-redux-i18n";
import { GridColumn, GridRow } from "@react/react-spectrum/Grid";
// // import geoPolData from '../../../../registration/config/geoPolData.json';
import { unregisterField } from "redux-form";
import Pagination from "@react/react-spectrum/Pagination";
import ReassignContactDisplay from "../singleUseComps/reassignContactsDisplay.jsx";
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";

class ContactDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupValidation: {},
      popupMode: null,
      contactSection1: [],
      contactSection2: [],
      contact_suffix: [],
      current_item: null,
      isLoading: true,
      currentPage: 1,
      noOfContacts: 2,
      reInvited: [],
    };
  }

  componentDidMount() {
    this.props.connector.fetchContacts(
      this.onFetchComplete,
      this.props.partnerData.partnerInfo.accountId,
      { page: 0, size: 10 },
    );
  }

  getContacts = (contacts) => {
    let retObj = {};
    let contact_suffix = [];
    let rearrangedContacts = [];
    let primaryObj = {};
    let secondaryObj = {};
    contacts &&
      contacts?.length > 0 &&
      contacts?.map((obj) => {
        if (obj?.mainContactType == "Primary") {
          primaryObj = obj;
        } else if (obj?.mainContactType == "Secondary") {
          secondaryObj = obj;
        } else {
          rearrangedContacts.push(obj);
        }
        return null;
      });

    if (secondaryObj && Object.keys(secondaryObj).length > 0) {
      rearrangedContacts.unshift(secondaryObj);
    }

    if (primaryObj != {} && Object.keys(primaryObj)?.length > 0) {
      rearrangedContacts.unshift(primaryObj);
    }

    rearrangedContacts.map((obj, index) => {
      Object.keys(obj).map((ele) => {
        retObj[ele === "recId" ? "contactId_" + index : ele + "_" + index] =
          ele === "additionalContactType" ? obj[ele].split(";") : obj[ele];
        return null;
      });
      contact_suffix.push(index);
      return null;
    });

    return { retObj: retObj, contact_suffix: contact_suffix };
  };

  onFetchComplete = (responseData) => {
    let contacts = this.getContacts(responseData.contacts);
    Object.keys(contacts.retObj).map((name) => {
      this.props.change(name, contacts.retObj[name]);
      return null;
    });
    if (responseData.noOfContacts)
      this.setState({
        isLoading: false,
        contact_suffix: contacts.contact_suffix,
        noOfContacts: responseData.noOfContacts,
      });
    else
      this.setState({
        isLoading: false,
        contact_suffix: contacts.contact_suffix,
      });
  };

  generateAdditionalContactFields = (counter) => {
    let contactSection1 = [];
    let resetData = {};
    let section13 = JSON.parse(JSON.stringify(formFields.section13));
    section13.map((obj) => {
      obj.name = obj.name + "_" + counter;
      if (
        obj.name === "active_" + counter &&
        this.props.formStates &&
        this.props.formStates["mainContactType_" + counter] === "Other"
      ) {
        obj.hide = false;
      }
      resetData[obj.name] =
        this.props.formStates && this.props.formStates[obj.name]
          ? this.props.formStates[obj.name]
          : null;
      contactSection1.push(obj);
      return obj;
    });
    let contactSection2 = [];
    let section14 = JSON.parse(JSON.stringify(formFields.section14));
    section14.map((obj) => {
      obj.name = obj.name + "_" + counter;
      if (
        obj.name === "email_" + counter &&
        this.props.formStates &&
        this.props.formStates["contactId_" + counter]
      ) {
        obj.disabled = true;
      }
      resetData[obj.name] =
        this.props.formStates && this.props.formStates[obj.name]
          ? this.props.formStates[obj.name]
          : null;
      contactSection2.push(obj);
      return obj;
    });
    return {
      contactSection1: contactSection1,
      contactSection2: contactSection2,
      resetData: resetData,
    };
  };

  popupValidation = (name, value) => {
    let popupValidation = this.state.popupValidation;
    popupValidation[name] = value;
    this.setState({ popupValidation: popupValidation });
    this.forceUpdate();
  };

  popupContactSave = () => {
    let body = {};
    this.state.contactSection1.map((obj) => {
      body[obj.name.split("_")[0]] = this.props.formStates[obj.name];
      return null;
    });
    this.state.contactSection2.map((obj) => {
      body[obj.name.split("_")[0]] = this.props.formStates[obj.name];
      return null;
    });
    body["additionalContactType"] = body["additionalContactType"].join(";");
    // additionalContactSection1
    if (this.state.popupMode === "editContact") {
      this.props.isSavingToggle(true);
      this.props.connector.updateContact(
        this.onContactSaveComplete,
        body,
        this.props.formStates["accountId"],
        this.props.formStates[
          "contactId_" + this.state.current_item.toString()
        ],
      );
    } else if (this.state.popupMode === "addContact") {
      body["mainContactType"] = "Other";
      this.props.isSavingToggle(true);
      this.props.connector.createContact(
        this.onContactSaveComplete,
        body,
        this.props.formStates["accountId"],
      );
    }
  };
  onContactSaveComplete = (response) => {
    if (response?.contactId) {
      let page = this.state.currentPage;
      let totalContacts = this.state.noOfContacts + 1;
      this.setState({ popupMode: null, noOfContacts: totalContacts });
      this.props.connector.fetchContacts(
        this.onFetchComplete,
        this.props.partnerData.partnerInfo.accountId,
        { page: page - 1, size: 10 },
      );
    } else {
      if (response?.isError) {
        toastPartnerApiFailure(response);
      }
    }
    this.props.isSavingToggle(false);
  };

  popupContactCancel = () => {
    this.state.contactSection1.map((obj) => {
      this.props.dispatch(unregisterField("managePartnership", obj.name));
      this.props.change(obj.name, this.state.resetData[obj.name]);
      if (this.state.popupMode === "addContact") {
        this.props.untouch(obj.name);
      }
      return null;
    });
    this.state.contactSection2.map((obj) => {
      this.props.dispatch(unregisterField("managePartnership", obj.name));
      this.props.change(obj.name, this.state.resetData[obj.name]);
      if (
        this.state.popupMode === "editContact" &&
        obj.name.startsWith("preferredLanguage") &&
        this.props.formStates["email_" + this.state.current_item] &&
        this.props.formStates[
          "email_" + this.state.current_item
        ].toLowerCase() === this.props.profile.email.toLowerCase()
      ) {
        this.props.setLang(this.state.resetData[obj.name]);
      }
      if (this.state.popupMode === "addContact") {
        this.props.untouch(obj.name);
      }
      return null;
    });

    this.setState({ popupMode: null });
  };

  onPageChange(page) {
    this.setState({ currentPage: page, isLoading: true });
    this.props.connector.fetchContacts(
      this.onFetchComplete,
      this.props.partnerData.partnerInfo.accountId,
      { page: page - 1, size: 10 },
    );
  }

  onReInviteComplete = (response) => {
    if (response?.item >= 0) {
      let reInvited = this.state.reInvited;
      reInvited.push(response?.item);
      this.setState({ reInvited: reInvited });
    }
  };

  reInviteUser = (item) => {
    this.props.connector.reInviteUser(
      this.onReInviteComplete,
      this.props.formStates["accountId"],
      this.props.formStates["contactId_" + item.toString()],
      item,
    );
  };

  render() {
    const formName = "managePartnership";
    const isSanctionRestricted = Boolean(this.props.isRestrictedSanctionCountry);
    const tableBody = [];
    {
      this.state.contact_suffix?.length > 0
        ? this.state.contact_suffix?.map((item) => {
            tableBody.push(
              <TR key={"contact_" + item}>
                <TD divider>
                  {isSanctionRestricted ? (
                    <span className="disabled-link">
                      <Translate value="managePartnership.ConsolePartnerBtnEdit" />
                    </span>
                  ) : (
                    <Link
                      onClick={() => {
                        this.setState({
                          popupMode: "editContact",
                          ...this.generateAdditionalContactFields(item),
                          current_item: item,
                        });
                      }}
                    >
                      <Translate value="managePartnership.ConsolePartnerBtnEdit" />
                    </Link>
                  )}
                  {!this.props.formStates["acceptedInvitation_" + item] &&
                  this.props.formStates["active_" + item] ? (
                    <span>
                      <>
                        {this.props.formStates[
                          "mainContactType_" + item
                        ]?.toLowerCase() !== "primary" ? (
                          <span style={{ padding: "0 15%" }}>|</span>
                        ) : null}
                      </>

                      {this.state.reInvited.includes(item) ||
                      isSanctionRestricted ? (
                        <span className="disabled-link">
                          <Translate value="managePartnership.ConsolePartnerConReinvite" />
                        </span>
                      ) : (
                        <>
                          {this.props.formStates[
                            "mainContactType_" + item
                          ]?.toLowerCase() !== "primary" ? (
                            <Link
                              onClick={() => {
                                this.reInviteUser(item);
                              }}
                            >
                              <Translate value="managePartnership.ConsolePartnerConReinvite" />
                            </Link>
                          ) : null}
                        </>
                      )}
                    </span>
                  ) : null}
                </TD>
                <TD divider>{this.props.formStates["firstName_" + item]}</TD>
                <TD divider>{this.props.formStates["lastName_" + item]}</TD>
                <TD divider>
                  {this.props.formStates["mainContactType_" + item]}
                </TD>
                <TD divider>{this.props.formStates["jobRole_" + item]}</TD>
                <TD divider>{this.props.formStates["email_" + item]}</TD>
                <TD divider>
                  {this.props.formStates["active_" + item]
                    ? "Active"
                    : "Deactivated"}
                </TD>
              </TR>,
            );
            return null;
          })
        : tableBody.push(
            <TR key="No_contact">
              <TD
                colSpan="7"
                style={{ color: "rgb(110, 110, 110)", fontWeight: "700" }}
              >
                No Contact(s) to show.
              </TD>
            </TR>,
          );
    }

    return (
      <div>
        {this.state.popupMode ? (
          <div className="overlay" style={{ zIndex: "2" }}></div>
        ) : null}
        <GridRow>
          <GridColumn>
            <Heading className="section-heading" variant="subtitle1">
              <Translate value="managePartnership.ConsolePartnerContactHeader" />
            </Heading>
          </GridColumn>
          <GridColumn>
            <Button
              className="button-action margin-action"
              variant="cta"
              disabled={isSanctionRestricted}
              onClick={() => {
                this.setState({
                  popupMode: "addContact",
                  ...this.generateAdditionalContactFields(
                    this.state.contact_suffix.length,
                  ),
                });
              }}
            >
              <Translate value="managePartnership.ConsolePartnerBtnAddContact" />
            </Button>
            <ReassignContactDisplay
              {...this.props}
              isRestrictedSanctionCountry={isSanctionRestricted}
            />
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn size={[12, 12, 12, 12]}>
            {this.state.isLoading ? (
              <div className="reassignWell">
                <Wait size="L" />
              </div>
            ) : (
              <Table id="table">
                <THead>
                  <TH>
                    <Translate value="managePartnership.ConsolePartnerContactAction" />
                  </TH>
                  <TH>
                    <Translate value="managePartnership.ConsolePartnerContactFName" />
                  </TH>
                  <TH>
                    <Translate value="managePartnership.ConsolePartnerContactLName" />
                  </TH>
                  <TH>
                    <Translate value="managePartnership.ReAssignMainContactTypeLabel" />
                  </TH>
                  <TH>
                    <Translate value="managePartnership.ConsolePartnerContactJob" />
                  </TH>
                  <TH>
                    <Translate value="managePartnership.ConsolePartnerContactEmail" />
                  </TH>
                  <TH>
                    <Translate value="managePartnership.ConsolePartnerContactStatus" />
                  </TH>
                </THead>

                <TBody>{tableBody}</TBody>
              </Table>
            )}
          </GridColumn>
        </GridRow>
        <GridRow align="center">
          <GridColumn>
            <Pagination
              style={{ display: "inline-flex" }}
              className="section-heading"
              defaultPage={1}
              mode="primary"
              onChange={(e) => {
                this.onPageChange(e);
              }}
              onNext={() => {
                this.onPageChange(this.state.currentPage + 1);
              }}
              onPrevious={() => {
                this.onPageChange(this.state.currentPage - 1);
              }}
              totalPages={Math.ceil(this.state.noOfContacts / 10)}
              variant="explicit"
            />
          </GridColumn>
        </GridRow>

        <GridRow>
          <GridColumn>
            {this.state.popupMode === "editContact" ||
            this.state.popupMode === "addContact" ? (
              <Dialog
                className="customDialog"
                variant="confirmation"
                title={
                  this.state.popupMode === "editContact" ? (
                    <Translate value="managePartnership.ConsolePartnerBtnEdit" />
                  ) : (
                    <Translate value="managePartnership.ConsolePartnerBtnAddContact" />
                  )
                }
                confirmLabel={
                  <Translate value="managePartnership.TrngSaveClose" />
                }
                onConfirm={() => {
                  this.popupContactSave();
                }}
                onCancel={() => {
                  this.popupContactCancel();
                }}
                confirmDisabled={
                  !Object.values(this.state.popupValidation).every(Boolean)
                }
                cancelLabel={<Translate value="managePartnership.TrngClose" />}
              >
                <GridColumn>
                  <Provider store={store}>
                    <GridRow>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="contact1"
                          updateValidation={this.popupValidation}
                          field={this.state.contactSection1}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="contact2"
                          updateValidation={this.popupValidation}
                          field={this.state.contactSection2}
                        />
                      </GridColumn>
                    </GridRow>
                  </Provider>
                </GridColumn>
              </Dialog>
            ) : null}
          </GridColumn>
        </GridRow>
      </div>
    );
  }
}

export default ContactDisplay;
